export default "__VITE_ASSET__BWY$nflB__"